<div class="fixed w-full h-full overflow-hidden -z-10 bg-primary">
    <img [hidden]="isHomePage" src="assets/images/logo/infinifi_background.png"
         alt="Infini-fi background"
         class="absolute bottom-0 right-0 h-100 w-auto opacity-10" />
  </div>

<router-outlet></router-outlet>
